module.exports = __webpack_public_path__ + "static/media/IMG_1454.a994afc4.PNG";